if ( typeof ShowMore !== 'function' ) {

    class ShowMore extends HTMLElement {

        constructor(){
            super();
            this.init();    
        }

        init() {
            const toggle = this.querySelector('.js-show-more'); 
            const panel = toggle.nextElementSibling;
            const panelHeight = panel.scrollHeight;

            // Remove only the event listener, preserve active state
            toggle.removeEventListener('click', this.onClickHandler);
            
            this.onClickHandler = e => {
                if ( ! e.currentTarget.classList.contains('active') ) {
                    this.openPanel(e.currentTarget, panel);
                } else {
                    this.closePanel(e.currentTarget, panel);
                }
            }

            // Check if this panel should be open by default
            const filterDisclosure = this.closest('.facets__disclosure');
            const shouldBeOpenByDefault = filterDisclosure && 
                ['Orientation', 'Color', 'Size', 'Colors', 'Sizes'].some(filterName => 
                    filterDisclosure.classList.contains(filterName)
                );

            if ( panelHeight <= parseInt(this.dataset.height)+10 ) {
                // Small content - always show as active/disabled
                toggle.classList.add("active", "disabled");
                toggle.parentElement.classList.add('show-more--active-not-active', "disabled");
                this.openPanel(toggle, panel, true); // Open without animation

            } else {
                // Check if we should restore previous state or use default
                const wasActive = toggle.classList.contains('active') || shouldBeOpenByDefault;
                
                if (wasActive && !toggle.classList.contains('active')) {
                    this.openPanel(toggle, panel, true); // Open without animation
                } else if (!wasActive && toggle.classList.contains('active')) {
                    this.closePanel(toggle, panel, true); // Close without animation
                }
                
                toggle.addEventListener('click', this.onClickHandler);
            }

            toggle.classList.add('init');
        }

        openPanel(toggle, panel, immediate = false) {
            toggle.classList.add("active");
            toggle.innerHTML = "<svg width='14' height='2' viewBox='0 0 14 2' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13 2H1C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0H13C13.55 0 14 0.45 14 1C14 1.55 13.55 2 13 2Z' fill='#333333'/></svg>";
            
            if (immediate) {
                panel.style.maxHeight = `initial`;
            } else {
                panel.style.maxHeight = `${panel.scrollHeight}px`;
                setTimeout(() => {
                    panel.style.maxHeight = `initial`;
                }, 100);
            }
        }

        closePanel(toggle, panel, immediate = false) {
            toggle.classList.remove("active");
            toggle.innerHTML = "<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13 8H8V13C8 13.55 7.55 14 7 14C6.45 14 6 13.55 6 13V8H1C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6H6V1C6 0.45 6.45 0 7 0C7.55 0 8 0.45 8 1V6H13C13.55 6 14 6.45 14 7C14 7.55 13.55 8 13 8Z' fill='#333333'/></svg>";
            
            if (immediate) {
                panel.style.maxHeight = "0px";
            } else {
                panel.style.maxHeight = `${panel.scrollHeight}px`;
                setTimeout(() => {
                    panel.style.maxHeight = "0px";
                }, 100);
            }
        }

    }

    if ( typeof customElements.get('show-more') == 'undefined' ) {
        customElements.define('show-more', ShowMore);
    }
}

// Store the state of panels before AJAX updates
function storePanelStates() {
    const panels = document.querySelectorAll('show-more');
    const states = {};
    
    panels.forEach((panel, index) => {
        const toggle = panel.querySelector('.js-show-more');
        if (toggle) {
            states[`panel-${index}`] = toggle.classList.contains('active');
        }
    });
    
    sessionStorage.setItem('filterPanelStates', JSON.stringify(states));
}

// Restore panel states after AJAX updates
function restorePanelStates() {
    const states = JSON.parse(sessionStorage.getItem('filterPanelStates') || '{}');
    const panels = document.querySelectorAll('show-more');
    
    panels.forEach((panel, index) => {
        const toggle = panel.querySelector('.js-show-more');
        const panelElement = toggle?.nextElementSibling;
        
        if (toggle && panelElement && states[`panel-${index}`]) {
            toggle.classList.add("active");
            toggle.innerHTML = "<svg width='14' height='2' viewBox='0 0 14 2' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13 2H1C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0H13C13.55 0 14 0.45 14 1C14 1.55 13.55 2 13 2Z' fill='#333333'/></svg>";
            panelElement.style.maxHeight = `initial`;
        }
    });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Store initial state
    setTimeout(() => {
        storePanelStates();
    }, 500);
});

// Enhanced AJAX event handling
document.addEventListener('shopify:section:load', function() {
    setTimeout(() => {
        restorePanelStates();
        storePanelStates();
    }, 300);
});

document.addEventListener('facet:reinitialized', function() {
    setTimeout(() => {
        restorePanelStates();
        storePanelStates();
    }, 300);
});

// Store state before any potential AJAX calls
const originalFetch = window.fetch;
window.fetch = function(...args) {
    storePanelStates();
    return originalFetch.apply(this, args);
};

// Also store state when form is submitted
document.addEventListener('submit', function(e) {
    if (e.target.matches('#FacetFiltersForm, #FacetFiltersFormMobile')) {
        storePanelStates();
    }
});